<template>
  <v-app>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="desserts"
      :single-select="singleSelect"
      item-key="ATTRIBUTE_ID"
      show-select
      style="padding:25px"
    >
      <template v-slot:top>
        <div>
          <div>
            <v-toolbar style="box-shadow:none !important">
              <v-toolbar-title
                ><b>{{ title }}</b></v-toolbar-title
              >
              <v-spacer></v-spacer>

              <v-spacer></v-spacer>
              <v-breadcrumbs>Master Data / INC Attribute</v-breadcrumbs>
              <v-btn icon v-on:click="getData">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-toolbar>

            <div style="padding:0px 25px">
              <v-layout row>
                <v-flex md8>
                  <v-btn
                    rounded
                    style="margin-top:15px"
                    color="primary"
                    large
                    v-on:click="modalForm"
                  >
                    <v-icon dark style="margin-right:10px">mdi-plus</v-icon>
                    Add Data
                  </v-btn>

                  <v-btn
                    rounded
                    class="ml-2"
                    style="margin-top:15px"
                    color="#1e6d42"
                    large
                    dark
                    :loading="loadingDownload"
                    v-on:click="exportData()"
                  >
                    <v-icon dark style="margin-right:10px"
                      >mdi-microsoft-excel</v-icon
                    >
                    Export
                  </v-btn>
                </v-flex>
                <v-flex md4>
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field
                      label=""
                      v-model="val"
                      v-on:keyup.enter="getData()"
                      placeholder="Enter Your Keywords"
                      solo
                      append-icon="search"
                    ></v-text-field>
                  </v-col>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>

        <v-dialog v-model="modal_form" max-width="500px">
          <v-card>
            <v-card-title>
              INC Attribute
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <div style="padding:10px">
                  <label>
                    Attribute Code
                  </label>
                  <v-text-field
                    v-model="attribute_code"
                    :rules="rules"
                    :disabled="disabled"
                    placeholder="Enter Attribute Code"
                    required
                    solo
                  ></v-text-field>

                  <label>
                    Attribute Desc
                  </label>
                  <v-text-field
                    v-model="attribute_desc"
                    :rules="rules"
                    placeholder="Enter Attribute Name"
                    required
                    solo
                  ></v-text-field>

                  <label>
                    Explanation
                  </label>
                  <v-text-field
                    v-model="explanation"
                    :rules="rules"
                    placeholder="Enter Explanation"
                    solo
                  ></v-text-field>

                  <label>
                    Sequence
                  </label>
                  <v-text-field
                    v-model="sequence"
                    :rules="rules"
                    placeholder="Enter Sequence"
                    required
                    solo
                  ></v-text-field>

                  <label>
                    INC
                  </label>
                  <v-autocomplete
                    item-text="INC_NAME"
                    item-value="INC_CODE"
                    v-model="inc_code"
                    :items="list_inc"
                    :rules="rules"
                    label="Choose INC"
                    v-bind:value="{ id: INC_CODE, text: INC_NAME }"
                    solo
                  ></v-autocomplete>
                </div>

                <div align="right">
                  <v-btn color="primary" text @click="modal_form = false">
                    Close
                  </v-btn>

                  <v-btn
                    color="primary"
                    text
                    :loading="loading"
                    v-on:click="processForm"
                  >
                    Process
                  </v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip color="success" v-if="item.STATUS == 'Y'">Active</v-chip>
        <v-chip color="error" v-if="item.STATUS == 'N'">Inactive</v-chip>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon medium class="mr-2" @click="edit(item)">
          mdi-file-edit
        </v-icon>

        <v-icon
          medium
          class="mr-2"
          color="error"
          @click="changeStatus(item, 'N')"
          v-if="item.STATUS == 'Y'"
        >
          mdi-close-circle
        </v-icon>

        <v-icon
          medium
          class="mr-2"
          color="success"
          @click="changeStatus(item, 'Y')"
          v-if="item.STATUS == 'N'"
        >
          mdi-check-circle
        </v-icon>
      </template>
    </v-data-table>
  </v-app>
</template>

<script>
export default {
  methods: {
    getData() {
      var self = this
      var val = self.val

      var url = self.base_url + "master/getdata/inc_attribute"
      this.axios
        .post(url, {
          param: val,
        })
        .then(function(response) {
          self.desserts = response.data
          self.loading = false
        })
    },
    exportData() {
      var self = this
      var val = self.val
      var url = self.base_url + "master/export/inc_attribute"

      var param = {
        param: val,
      }

      var responseType = {
        responseType: "arraybuffer",
      }

      self.loadingDownload = true

      self.axios.post(url, param, responseType).then(function(response) {
        const blob = new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", "inc_attribute.xlsx")
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        self.loadingDownload = false
      })
    },
    modalForm() {
      var self = this
      self.modal_form = true
      self.reset()
      self.disabled = false
    },
    edit(item) {
      var self = this
      self.modal_form = true

      self.attribute_id = item.ATTRIBUTE_ID
      self.attribute_code = item.ATTRIBUTE_CODE
      self.attribute_desc = item.ATTRIBUTE_DESC
      self.explanation = item.EXPLANATION
      self.sequence = item.SEQUENCE
      self.inc_code = parseInt(item.INC_CODE)
      self.type = "UPDATE"
      self.disabled = true
    },
    reset() {
      this.attribute_id = ""
      this.$refs.form.reset()
      this.type = "INSERT"
    },
    processForm() {
      var self = this
      if (self.$refs.form.validate()) {
        var url = self.base_url + "master/process/add_inc_attribute"
        self.loading = true

        self.axios
          .post(url, {
            attribute_id: self.attribute_id,
            attribute_code: self.attribute_code,
            attribute_desc: self.attribute_desc,
            explanation: self.explanation,
            sequence: self.sequence,
            inc_code: self.inc_code,
          })
          .then(function(response) {
            if (response.data) {
              self.modal_form = false
              alert("Data succesfully saved")
            } else {
              alert(response.data.messages)
            }
            self.getData()
            self.loading = false
          })
      }
    },
    changeStatus(item, status) {
      var self = this
      var url = self.base_url + "master/process/change_status"

      var text_confirm = "Are you sure you want to Deactivated this data ?"

      if (status == "Y") {
        text_confirm = "Are you sure you want to Activated this data ?"
      }

      this.$dialog.confirm({
        text: text_confirm,
        overlay: true,
        actions: {
          false: "No",
          true: {
            color: "red",
            text: "Yes",
            handle: () => {
              self.axios
                .post(url, {
                  id: item.ATTRIBUTE_ID,
                  status: status,
                  table: "tm_inc_attribute",
                  field: "ATTRIBUTE_ID",
                })
                .then(function(response) {
                  alert(response.data.message)
                  self.getData()
                })
            },
          },
        },
      })
    },
    getInc() {
      var self = this
      var url = self.base_url + "dropdown/inc"
      self.axios.get(url).then(function(response) {
        self.list_inc = response.data
      })
    },
  },
  mounted() {
    this.getData()
    this.getInc()
  },
  data() {
    return {
      name: "AttributeINC",
      title: "Data Attribute INC",
      dialog: false,
      widgets: false,
      singleSelect: false,
      selected: [],
      loading: true,
      loadingDownload: false,
      showSelect: false,
      val: "",
      headers: [
        { text: "Attribute Code", value: "ATTRIBUTE_CODE", width: 220 },
        { text: "Attribute Desc", value: "ATTRIBUTE_DESC", width: 250 },
        { text: "Sequence", value: "SEQUENCE", width: 120 },
        { text: "Explanation", value: "EXPLANATION", width: 180 },
        { text: "INC Code", value: "INC_CODE", width: 150 },
        { text: "Status", value: "status", sortable: true, width: 150 },
        { text: "Action", value: "action", sortable: false, width: 120 },
      ],
      desserts: [],
      modal_detail: false,
      detail: [],
      modal_form: false,
      rules: [
        (v) => !!v || "Form is required",
        //v => (v && v.length <= 10) || 'This form must be less than 10 characters',
      ],
      list_inc: [],

      //form..............................
      attribute_id: "",
      attribute_code: "",
      attribute_desc: "",
      explanation: "",
      sequence: "",
      inc_code: "",
      type: "",
      disabled: false,

      //storage.....................................
      storage_user_id: localStorage.getItem("user_id"),
      storage_username: localStorage.getItem("username"),
      storage_fullname: localStorage.getItem("fullname"),
      storage_INC_id: localStorage.getItem("INC_id"),
      storage_INC_name: localStorage.getItem("INC_name"),
      storage_role: localStorage.getItem("role"),
      storage_departement_id: localStorage.getItem("departement_id"),
    }
  },
}
</script>
